module.exports = __webpack_public_path__ + "fonts/Inter-800-cyrillic-ext71.857026d.woff2";